import "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdAltRoute } from "react-icons/md";
//#region src/modules/AuthWrapper2/components/Login/views/LegacyUser.tsx
function LegacyUser({ onBack }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "space-y-lg text-center",
		children: [
			/* @__PURE__ */ jsx(Icon, {
				Icon: MdAltRoute,
				size: "xxl",
				color: "subtle"
			}),
			/* @__PURE__ */ jsxs("p", { children: [
				"You are trying to login with an account for our Legacy App. If you are trying to access the old system, please visit",
				" ",
				/* @__PURE__ */ jsx("a", {
					href: "https://app.therms.io",
					className: "text-color-info hover:text-color-info-light active:text-color-info-dark font-medium transition-colors",
					children: "THERMS Legacy"
				}),
				"."
			] }),
			/* @__PURE__ */ jsxs("p", { children: [
				"If you are sure you have an account for ",
				/* @__PURE__ */ jsx("strong", { children: "THERMS Infinity" }),
				", please",
				/* @__PURE__ */ jsx(Button, {
					onClick: onBack,
					subtle: true,
					variant: "main",
					children: "go back"
				}),
				"and try again."
			] })
		]
	});
}
//#endregion
export { LegacyUser };

//# sourceMappingURL=LegacyUser.js.map